import React, { Component } from 'react';
import {
  Grid,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import { getCostCentres, createCostCentre, updateCostCentre } from '../../api/resources/CostCentres';
import CostCentreEntryNew from "./CostCentreEntryNew";
import CostCentreEntry from "./CostCentreEntry";
import { sortBy } from 'lodash'

class CostCentres extends Component {

  constructor(props) {
    super(props);
    this.state = {
      costCentres: null
    }
    this.handleCreateCostCentre = this.handleCreateCostCentre.bind(this);
    this.handleEditCostCentre = this.handleEditCostCentre.bind(this);
    this.handleUpdateCostCentre = this.handleUpdateCostCentre.bind(this);
    this.handleCancelEditCostCentre = this.handleCancelEditCostCentre.bind(this);
  }

  componentDidMount() {
    getCostCentres().then(costCentres => {
      this.setState({costCentres: sortBy(costCentres, 'name')})
    })
  }

  
  handleCancelEditCostCentre(costCentre) {
    let { costCentres } = this.state;
    costCentres = costCentres.map(_costCentre => {
      return costCentre.id === _costCentre.id
        ? { ..._costCentre, editing: false }
        : _costCentre;
    })
    this.setState({ costCentres });
  }
  
  handleEditCostCentre(costCentre) {
    let { costCentres } = this.state;
    costCentres = costCentres.map(_costCentre => {
      return costCentre.id === _costCentre.id
      ? { ..._costCentre, editing: true }
      : _costCentre;
    })
    this.setState({ costCentres });
  }

  handleUpdateCostCentre(costCentre) {
    const { costCentres } = this.state;
    return new Promise((resolve, reject) => {
      updateCostCentre(costCentre.id, costCentre).then(res => {
        this.setState({
          costCentres: costCentres.map(_costCentre => {
            return _costCentre.id === costCentre.id
              ? { ...costCentre, editing: false }
              : _costCentre;
          })
        })
        resolve(res);
      }).catch(reject);
    });
  }

  handleCreateCostCentre(costCentre) {
    return new Promise((resolve, reject) => {
      createCostCentre(costCentre).then(res => {
        this.setState({
          costCentres: [...this.state.costCentres, res]
        })
        resolve(res);
      }).catch(reject);
    });
  }

  render() {

    const { costCentres } = this.state;
    const { user } = this.props;

    return (
      <>
        <Grid item xs={12} md={12} lg={8}>
          <Typography variant="h6">
            Cost centres
          </Typography>
          {costCentres &&
            <List>
              <Paper style={{ margin: 16 }}>
                <ListItem>
                  <Grid container>
                    <Grid xs={6} md={6} item style={{ paddingRight: 16 }}>
                      <ListItemText primaryTypographyProps={{style: {fontWeight: '700'}}} primary='Cost centre name' />
                    </Grid>
                    <Grid xs={4} md={4} item style={{ paddingRight: 16 }}>
                      <ListItemText primaryTypographyProps={{style: {fontWeight: '700'}}} primary='Escalation threshold' />
                    </Grid>
                    <Grid xs={2} md={2} item>
                    </Grid>
                  </Grid>
                </ListItem>
              </Paper>
              {costCentres.map((costCentre, idx) => (
                <React.Fragment key={idx}>
                  { user.type === "admin" && costCentre.editing &&(
                    <CostCentreEntryNew
                      costCentre={costCentre}
                      onUpdate={this.handleUpdateCostCentre}
                      onCancel={this.handleCancelEditCostCentre}
                    />
                  )}
                  { !costCentre.editing && <CostCentreEntry user={user} resource={costCentre} onEdit={this.handleEditCostCentre} /> }
                </React.Fragment>
              ))}
              { user.type === "admin" && <CostCentreEntryNew onCreate={this.handleCreateCostCentre} /> }
            </List>
          }
        </Grid>
      </>
    );
  }
}
export default CostCentres;